export const settings = {
  title: 'Settings',
};
